import {TreeItem} from "@mui/lab";
import {Box, Typography} from "@mui/material";
import {Folder} from "@mui/icons-material";
import React from "react";
import {FileItem} from "./FileItem";
import {IFileSystemContent} from "./content/FileSystemContent";

interface IProps {
    content: IFileSystemContent
    path: string
    onSelected: (selected: string) => void
}
export function FolderItem({content, path, onSelected}: IProps) {
    const folder = content.getFolder(path);

    if (! folder) return null;

    const folderNames: {[folder: string]: string} = Object.fromEntries(
        (folder.folders || []).map(folder => [folder, content.getFolder(folder)?.name || ""]));
    const fileNames: {[file: string]: string} = Object.fromEntries(
        (folder.files || []).map(file => [file, content.getFile(file)?.name || ""]));

    return (
        <TreeItem nodeId={path} label={
            <Box display="flex" m={1}>
                <Folder color="disabled" fontSize="small" sx={{marginRight: 1}}/>
                <Typography variant="body2">{folder.name}</Typography>
            </Box>
        } onClick={() => onSelected(path)}>
            <Box>
                {Object.keys(folderNames)
                    .sort((lhs, rhs) => folderNames[lhs].localeCompare(folderNames[rhs]))
                    .map(key => <FolderItem content={content} key={key} onSelected={onSelected} path={key}/>)
                }
                {Object.keys(fileNames)
                    .sort((lhs, rhs) => fileNames[lhs].localeCompare(fileNames[rhs]))
                    .map(key => <FileItem content={content} key={key} onSelected={onSelected} path={key}/>)
                }
            </Box>
        </TreeItem>
    );
}
